export default "__VITE_ASSET__B87$O9Ll__"